import { useState } from "react";
import axios from "axios";
import { validateForm } from "../utils/formValidation.js";
import { buildUddfData } from "../utils/uddfBuilder.js";
import auth from "../../../config/firebase.js"; // Assuming this path is correct

const useSubmission = (
  formState,
  userObjectId,
  dispatch,
  showSnackbar,
  resetForm,
  setTurnstileToken,
  turnstileToken
) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const handleSubmit = async (e) => {
    e?.preventDefault();

    if (!turnstileToken) {
      showSnackbar(
        "Please complete the security check before submitting.",
        "error"
      );
      return;
    }

    const validationError = validateForm(formState);
    if (validationError) {
      showSnackbar(validationError, "error");
      return;
    }

    setIsSubmitting(true);
    const user = auth.currentUser;
    const token = user && (await user.getIdToken());

    const formData = new FormData();
    formData.append("turnstileToken", turnstileToken);

    try {
      const tideResponse = await axios.get(
        `/api/tides/closest-tide-station?lat=${formState.markerPosition.lat}&lon=${formState.markerPosition.lng}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const tideData = tideResponse.data;

      const formDataWithTide = {
        ...formState,
        closestTideStation: tideData.id,
      };

      const uddfData = buildUddfData(formDataWithTide, userObjectId);
      formData.append("divesitedata", JSON.stringify(uddfData));

      // Append images
      const mediaImageDescriptions = [];
      if (formDataWithTide.mediaImages?.length > 0) {
        formDataWithTide.mediaImages.forEach((imageObject) => {
          if (imageObject?.file) {
            formData.append(`mediaImages`, imageObject.file);
            mediaImageDescriptions.push(imageObject.description || "");
          }
        });
        formData.append(
          "mediaImageDescriptions",
          JSON.stringify(mediaImageDescriptions)
        );
      }

      if (formDataWithTide.heroImage?.file) {
        formData.append("heroImage", formDataWithTide.heroImage.file);
        formData.append(
          "heroImageDescription",
          formDataWithTide.heroImage.description || ""
        );
      }

      if (formDataWithTide.diagramImage?.file) {
        formData.append("diagramImage", formDataWithTide.diagramImage.file);
        formData.append(
          "diagramImageDescription",
          formDataWithTide.diagramImage.description || ""
        );
      }

      const response = await axios.post(
        "/api/divesites/create",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const json = response.data;
      dispatch({ type: "CREATE_DIVESITE", payload: json });
      showSnackbar("Thank you for creating a divesite!", "success");
      setModalOpen(true); // Set modal open on success
      resetForm();

      // Reset Turnstile token after successful submission
      setTurnstileToken(null);
      if (window.turnstile) {
        try {
          window.turnstile.reset(); // Reset the actual widget
        } catch (error) {
          console.error("Error resetting Turnstile widget:", error);
        }
      }
    } catch (error) {
      console.error("Error in submit process:", error);
      const errorMessage = error.response?.data?.message || error.message;
      showSnackbar(`Failed: ${errorMessage}`, "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    isSubmitting,
    modalOpen,
    setModalOpen,
    handleSubmit,
  };
};

export default useSubmission;
